import { IonButton } from "@ionic/react";
import { ComponentProps } from "react";

import styles from "@components/buttons/CircleIconButton.module.css";
import Icon from "@components/text/Icon";
import useKeyboardFocus from "@hooks/useKeyboardFocus";
import { IconName } from "@utils/iconUtils";

type ButtonProps = Pick<
  ComponentProps<typeof IonButton>,
  "disabled" | "expand" | "href" | "onClick" | "onKeyUp" | "rel" | "routerLink" | "tabIndex" | "target" | "type"
>;

export type Color = "success-500" | "danger-300" | "secondary-500";

type Props = ButtonProps & {
  ariaLabelKey: string;
  color?: Color;
  disabled?: boolean;
  icon: IconName;
  textKey?: string;
};

const CircleIconButton = ({ ariaLabelKey, color = "success-500", icon, textKey, ...buttonProps }: Props) => {
  const keyboardFocus = useKeyboardFocus();

  return (
    <IonButton
      className={`${styles.button} ${keyboardFocus ? styles.focus : ""}  ${styles[color]} ${
        !textKey ? styles.noText : ""
      }`}
      mode="md"
      {...buttonProps}
    >
      <Icon color="white" icon={icon} size="small" />
    </IonButton>
  );
};

export default CircleIconButton;
